import { FieldType } from '@wix/wix-data-schema-types'
import {
  TEXT_ROLE,
  TEXT_ROLE_RICH_TEXT_SUBROLE,
  TEXT_ROLE_LINK_SUBROLE,
  TEXT_ROLE_SUBMIT_FEEDBACK_SUBROLE,
} from '@wix/wix-data-client-common-standalone'
import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'

const {
  text,
  email,
  number,
  url,
  boolean,
  date,
  dateTime,
  time,
  richText,
  address,
  stringArray,
  color,
} = FieldType

export default (): DataBindingComponentModel => ({
  componentName: 'Element_Name_Text',
  isConnectGfppEnabled: true,
  supportsDefaultSelectedDataset: true,
  panel: {
    height: 321,
    title: 'Connect_Panel_Title_Text',
    helpId: 'a0b9d29b-65b9-42eb-a7a5-6fb3f2cd408c',
  },
  sections: [
    {
      role: TEXT_ROLE,
      bindings: [
        {
          title: 'Connect_Panel_Connect_Text_Label',
          prop: '$text',
          supportedFieldTypes: [
            text,
            email,
            number,
            url,
            boolean,
            date,
            dateTime,
            richText,
            address,
            stringArray,
            time,
          ],
          defaultFieldType: text,
          supportsReferenceFields: true,
          supportedBehaviors: ['saveFailureFeedback', 'saveSuccessFeedback'],
          requiresPrimaryConnection: true,
          supportsUrlTarget: true,
          supportsUrlRel: true,
          supportsTotalCount: true,
        },
        {
          title: 'Connect_Panel_Connect_Text_Color',
          prop: 'style.color',
          supportedFieldTypes: [color],
          defaultFieldType: color,
          supportsReferenceFields: true,
          requiresPrimaryConnection: true,
        },
      ],
      manifest: {
        gfpp: {
          desktop: {
            mainAction1: {
              actionId: 'text_live_preview_gfpp_desktop_main_action',
              label: 'Text_Live_Preview_GFPP_Desktop_Main_Action',
            },
            mainAction2: 'DEFAULT1',
          },
        },
        behavior: { dataEditOptions: 'TEXT_STYLE_ONLY' as const },
      },
      subroles: [
        {
          name: TEXT_ROLE_RICH_TEXT_SUBROLE,
          conditions: [
            {
              connectedProps: [{ prop: '$text', fieldType: richText }],
            },
          ],
          manifest: {
            gfpp: {
              desktop: {
                mainAction2: 'HIDE' as const,
              },
            },
          },
        },
        {
          name: TEXT_ROLE_LINK_SUBROLE,
          conditions: [{ connectedProps: [{ prop: '$text', fieldType: url }] }],
          manifest: {
            gfpp: {
              desktop: {
                iconButtons: {
                  link: {
                    behavior: 'HIDE' as const,
                  },
                },
              },
            },
          },
        },
        {
          name: TEXT_ROLE_SUBMIT_FEEDBACK_SUBROLE,
          conditions: [
            {
              connectedBehaviors: [{ behavior: 'saveSuccessFeedback' }],
            },
            {
              connectedBehaviors: [{ behavior: 'saveFailureFeedback' }],
            },
          ],
          manifest: {
            gfpp: {
              desktop: {
                mainAction1: 'DEFAULT1',
                mainAction2: 'DEFAULT2',
              },
            },
            behavior: { dataEditOptions: 'FULL' as const },
          },
        },
      ],
    },
  ],
  compactErrorPanel: true,
})
